var _defs, _g, _g2, _polygon, _polyline, _circle, _circle2, _g3, _path, _polygon2, _polygon3, _polygon4, _polygon5, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse, _polygon6, _polygon7, _polygon8, _path10, _g4, _ellipse2, _g5, _g6, _g7, _path11, _polygon9, _polygon10, _polygon11, _polygon12, _path12, _path13, _circle3, _circle4, _path14, _polygon13, _polygon14, _ellipse3, _path15, _polygon15, _polygon16, _path16, _path17, _path18, _path19, _polygon17, _polygon18, _polygon19, _ellipse4, _path20, _path21, _path22, _g8, _path23, _g9, _path24, _path25, _g10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlider1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "521px",
    height: "400px",
    viewBox: "0 0 521 400",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Products") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "79.4734151%",
    y1: "49.5966477%",
    x2: "-56.8558282%",
    y2: "51.4628243%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F9FF",
    stopOpacity: 0.07,
    offset: "10%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6F3FF",
    stopOpacity: 0.26,
    offset: "31%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DE9FF",
    stopOpacity: 0.56,
    offset: "60%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09DCFF",
    stopOpacity: 0.96,
    offset: "97%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DBFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "79.0223735%",
    y1: "49.3355728%",
    x2: "-91.1040856%",
    y2: "53.2320853%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F9FF",
    stopOpacity: 0.07,
    offset: "10%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6F3FF",
    stopOpacity: 0.26,
    offset: "31%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DE9FF",
    stopOpacity: 0.56,
    offset: "60%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09DCFF",
    stopOpacity: 0.96,
    offset: "97%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DBFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "110.461362%",
    y1: "49.287248%",
    x2: "-10.268694%",
    y2: "50.7085676%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3FBFF",
    stopOpacity: 0.01,
    offset: "23%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFAFF",
    stopOpacity: 0.04,
    offset: "36%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF8FF",
    stopOpacity: 0.1,
    offset: "47%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9F5FF",
    stopOpacity: 0.18,
    offset: "57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0F2FF",
    stopOpacity: 0.28,
    offset: "66%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91EEFF",
    stopOpacity: 0.41,
    offset: "75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CE9FF",
    stopOpacity: 0.56,
    offset: "83%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41E3FF",
    stopOpacity: 0.74,
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12DDFF",
    stopOpacity: 0.93,
    offset: "98%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DBFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.805032788%",
    y1: "49.9962933%",
    x2: "100.79437%",
    y2: "49.9962933%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFEFF",
    stopOpacity: 0.65,
    offset: "29%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF",
    stopOpacity: 0.37,
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FCFF",
    stopOpacity: 0.17,
    offset: "75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF",
    stopOpacity: 0.05,
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-6.04311847%",
    y1: "49.9899376%",
    x2: "122.593641%",
    y2: "49.9899376%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFF6FF",
    stopOpacity: 0.16,
    offset: "18%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EE9FF",
    stopOpacity: 0.55,
    offset: "57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DBFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0063943%",
    y1: "-109.706535%",
    x2: "50.0063943%",
    y2: "94.8876729%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "14.0023112%",
    y1: "50%",
    x2: "70.5412173%",
    y2: "50%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2F0FC",
    stopOpacity: 0.17,
    offset: "19%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2D5F4",
    stopOpacity: 0.59,
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84BBEC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0003761%",
    y1: "-109.709514%",
    x2: "50.0003761%",
    y2: "94.879068%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4674C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "13.661166%",
    y1: "50%",
    x2: "99.9140987%",
    y2: "50%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF",
    stopOpacity: 0.01,
    offset: "20%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF",
    stopOpacity: 0.05,
    offset: "33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6FBFF",
    stopOpacity: 0.11,
    offset: "45%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FCFF",
    stopOpacity: 0.19,
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FCFF",
    stopOpacity: 0.3,
    offset: "65%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FDFF",
    stopOpacity: 0.44,
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFDFF",
    stopOpacity: 0.6,
    offset: "83%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0.78,
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.99,
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "32.8684234%",
    y1: "50%",
    x2: "119.16053%",
    y2: "50%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF",
    stopOpacity: 0.01,
    offset: "20%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF",
    stopOpacity: 0.05,
    offset: "33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6FBFF",
    stopOpacity: 0.11,
    offset: "45%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FCFF",
    stopOpacity: 0.19,
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FCFF",
    stopOpacity: 0.3,
    offset: "65%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FDFF",
    stopOpacity: 0.44,
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFDFF",
    stopOpacity: 0.6,
    offset: "83%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0.78,
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.99,
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "35.2127648%",
    y1: "49.9970402%",
    x2: "121.562797%",
    y2: "49.9970402%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF",
    stopOpacity: 0.01,
    offset: "20%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF",
    stopOpacity: 0.05,
    offset: "33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6FBFF",
    stopOpacity: 0.11,
    offset: "45%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FCFF",
    stopOpacity: 0.19,
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FCFF",
    stopOpacity: 0.3,
    offset: "65%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FDFF",
    stopOpacity: 0.44,
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFDFF",
    stopOpacity: 0.6,
    offset: "83%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0.78,
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.99,
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.663759422%",
    y1: "49.9966432%",
    x2: "100.164066%",
    y2: "49.9966432%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF",
    stopOpacity: 0.02,
    offset: "12%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6FBFF",
    stopOpacity: 0.06,
    offset: "25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6FCFF",
    stopOpacity: 0.14,
    offset: "38%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FCFF",
    stopOpacity: 0.25,
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FDFF",
    stopOpacity: 0.4,
    offset: "63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFDFF",
    stopOpacity: 0.57,
    offset: "76%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0.78,
    offset: "88%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "16.8069437%",
    y1: "49.9961231%",
    x2: "116.426516%",
    y2: "49.9961231%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF",
    stopOpacity: 0.01,
    offset: "20%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF",
    stopOpacity: 0.05,
    offset: "33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6FBFF",
    stopOpacity: 0.11,
    offset: "45%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FCFF",
    stopOpacity: 0.19,
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FCFF",
    stopOpacity: 0.3,
    offset: "65%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FDFF",
    stopOpacity: 0.44,
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFDFF",
    stopOpacity: 0.6,
    offset: "83%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0.78,
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.99,
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-5.52108227%",
    y1: "-14.0848101%",
    x2: "188.693294%",
    y2: "207.801002%",
    id: "linearGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F9FF",
    stopOpacity: 0.07,
    offset: "10%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6F3FF",
    stopOpacity: 0.26,
    offset: "31%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DE9FF",
    stopOpacity: 0.56,
    offset: "60%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09DCFF",
    stopOpacity: 0.96,
    offset: "97%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DBFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "114.665614%",
    y1: "-2.21338457%",
    x2: "31.3549197%",
    y2: "68.2341478%",
    id: "linearGradient-15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFFAFB",
    stopOpacity: 0.03,
    offset: "11%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFF6F1",
    stopOpacity: 0.11,
    offset: "25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5EFE0",
    stopOpacity: 0.25,
    offset: "42%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0E6C8",
    stopOpacity: 0.44,
    offset: "59%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70DAAA",
    stopOpacity: 0.68,
    offset: "78%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37CC85",
    stopOpacity: 0.97,
    offset: "98%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32CB82",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "125.822538%",
    y1: "79.6298687%",
    x2: "-69.6739111%",
    y2: "6.13847616%",
    id: "linearGradient-16"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFEFF",
    stopOpacity: 0.65,
    offset: "29%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF",
    stopOpacity: 0.37,
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FCFF",
    stopOpacity: 0.17,
    offset: "75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF",
    stopOpacity: 0.05,
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "85.0882532%",
    y1: "50.0411523%",
    x2: "-15.6889367%",
    y2: "50.0411523%",
    id: "linearGradient-17"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6FBFF",
    stopOpacity: 0.07,
    offset: "10%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FCFF",
    stopOpacity: 0.26,
    offset: "31%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFDFF",
    stopOpacity: 0.56,
    offset: "60%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.96,
    offset: "97%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "117.159212%",
    y1: "49.9588477%",
    x2: "-71.0596379%",
    y2: "49.9588477%",
    id: "linearGradient-18"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6FBFF",
    stopOpacity: 0.07,
    offset: "10%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FCFF",
    stopOpacity: 0.26,
    offset: "31%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFDFF",
    stopOpacity: 0.56,
    offset: "60%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.96,
    offset: "97%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "118.433609%",
    y1: "50.0411523%",
    x2: "-20.8192715%",
    y2: "50.0411523%",
    id: "linearGradient-19"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6FBFF",
    stopOpacity: 0.07,
    offset: "10%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FCFF",
    stopOpacity: 0.26,
    offset: "31%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFDFF",
    stopOpacity: 0.56,
    offset: "60%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.96,
    offset: "97%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Product-Overview-&-Products-Pages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Product-Overview_01",
    transform: "translate(-769.000000, -143.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Products",
    transform: "translate(769.000000, 143.000000)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.5,
    transform: "translate(317.000000, 297.000000)",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "186.94 51.56 196.1 0.12 9.65 0.12 0.5 51.56"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(276.000000, 348.000000)",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "197.08 52 206.23 0.56 9.79 0.56 0.63 52"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero",
    points: "480.62 297.1 489.77 245.66 306.88 245.66 297.73 297.1"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "url(#linearGradient-4)",
    strokeWidth: 4,
    points: "331.36 391.06 409.5 301.49 425.31 327.74 464.33 277.38 479.51 300.43 518.93 256.17"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    cx: 409.31,
    cy: 301.99,
    r: 7.49
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 409.31,
    cy: 301.99,
    r: 4.5
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.4,
    transform: "translate(333.000000, 119.000000)",
    fill: "url(#linearGradient-5)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.47,
    y: 0.88,
    width: 91.84,
    height: 49.69
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M395.5,169.53 L435.78,169.53 C438.918743,169.420171 441.5712,167.1691 442.19,164.09 L449.09,125.32 C449.405648,123.975912 449.076587,122.561504 448.200064,121.494773 C447.32354,120.428042 445.999784,119.830967 444.62,119.88 L404.34,119.88 C401.200256,119.992503 398.546337,122.241306 397.92,125.32 L391,164.09 C390.687057,165.438869 391.021338,166.856513 391.903934,167.923474 C392.78653,168.990434 394.116379,169.584538 395.5,169.53 L395.5,169.53 Z",
    id: "Path",
    fill: "#EDF0F4",
    fillRule: "nonzero"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EDF0F4",
    fillRule: "nonzero",
    points: "456.08 145.38 443.89 151.76 446.16 139"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(403.000000, 131.000000)",
    fill: "#B4BED5",
    fillRule: "nonzero"
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "18.77 0.51 1.2 0.51 0.5 4.43 18.07 4.43"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(401.000000, 142.000000)",
    fill: "#B4BED5",
    fillRule: "nonzero"
  }, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "36.13 0.58 1.26 0.58 0.53 4.5 35.41 4.5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(400.000000, 153.000000)",
    fill: "#B4BED5",
    fillRule: "nonzero"
  }, _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "11.86 0.66 0.98 0.66 0.18 4.9 11.07 4.9"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M315.72,399.62 L157.92,399.62 C149.67,399.62 144.18,392.93 145.64,384.69 L211.47,14.93 C212.94,6.69 220.81,0 229.06,0 L376.66,0 C394.06,0 405.66,14.1 402.55,31.5 L340.81,378.32 C338.71,390.08 327.48,399.62 315.72,399.62 Z",
    id: "Path",
    fill: "#9BA9C5",
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M298.17,399.62 L154.4,399.62 C140.52,399.62 131.27,388.37 133.75,374.49 L195.94,25.13 C198.41,11.25 211.67,0 225.55,0 L369.31,0 C383.19,0 392.44,11.25 390,25.13 L327.8,374.49 C325.3,388.37 312.05,399.62 298.17,399.62 Z",
    id: "Path",
    fill: "#CDD4E2",
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M292.32,390.25 L163.59,390.25 C150.86,390.25 142.38,379.93 144.65,367.25 L204.25,32.45 C206.51,19.73 218.67,9.45 231.39,9.45 L360.13,9.45 C372.85,9.45 381.33,19.77 379.07,32.45 L319.47,367.25 C317.2,379.93 305.05,390.25 292.32,390.25 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(218.000000, 22.000000)",
    fill: "#B4BED5",
    fillRule: "nonzero"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.81,7.69 L4.13,7.69 C3.16080437,7.7153502 2.23457301,7.29013316 1.62201829,6.53862832 C1.00946357,5.78712349 0.77974385,4.7941769 1,3.85 L1,3.85 C1.43102102,1.685542 3.28512031,0.0957241259 5.49,6.50521303e-19 L34.18,6.50521303e-19 C35.1526569,-0.0317068276 36.0847254,0.39080858 36.7019354,1.14321703 C37.3191455,1.89562548 37.5512685,2.89231493 37.33,3.84 L37.33,3.84 C36.896299,6.01497333 35.0262694,7.60780831 32.81,7.69 Z",
    id: "Path"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(338.000000, 22.000000)",
    fill: "#B4BED5",
    fillRule: "nonzero"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.51,7.69 L4,7.69 C3.02561662,7.72490674 2.09061818,7.30375251 1.47107318,6.5508877 C0.851528174,5.79802288 0.618206896,4.79944682 0.84,3.85 L0.84,3.85 C1.27544832,1.66797026 3.15614644,0.0731051144 5.38,4.33680869e-19 L19.87,4.33680869e-19 C20.841407,-0.0261427836 21.7698577,0.40038403 22.3828628,1.15439984 C22.9958679,1.90841566 23.2238873,2.90438404 23,3.85 L23,3.85 C22.5649401,6.01050423 20.711839,7.59533903 18.51,7.69 L18.51,7.69 Z",
    id: "Path"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M292.15,373 L171.5,373 C164.04,373 159.07,366.95 160.4,359.49 L160.4,359.49 C161.73,352 168.85,346 176.31,346 L297,346 C304.46,346 309.43,352.05 308.1,359.51 L308.1,359.51 C306.74,366.92 299.61,373 292.15,373 Z",
    id: "Path",
    fill: "#EDF0F4",
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M294,47.08 C291.957427,44.6778218 288.953016,43.3075171 285.8,43.3394353 L106.63,43.3394353 C100.559734,43.4849451 95.4066833,47.8311418 94.24,53.79 L87.34,92.55 C86.7462516,95.685975 87.5740151,98.9237758 89.6,101.39 C90.892486,102.920532 92.6017376,104.042663 94.52,104.62 L94.52,104.62 L176.87,132.34 L181.72,105.11 L277,105.11 C283.066239,104.968903 288.216908,100.625366 289.38,94.67 L296.28,55.9 C296.862042,52.7674817 296.027214,49.5380166 294,47.08 L294,47.08 Z",
    id: "Path",
    fill: "url(#linearGradient-6)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("image", {
    id: "Bitmap",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply"
    },
    x: 78.22,
    y: 34.3,
    width: 228,
    height: 80,
    xlinkHref: "data:image/png;base64,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"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M277,99.06 L97.79,99.06 C96.4076209,99.1089282 95.0814121,98.5107896 94.2030359,97.4422292 C93.3246596,96.3736689 92.9944774,94.9567782 93.31,93.61 L100.22,54.85 C100.835454,51.7689285 103.489856,49.5162069 106.63,49.41 L285.84,49.41 C287.221508,49.3577541 288.548202,49.9534621 289.427065,51.0206524 C290.305928,52.0878427 290.636184,53.5041463 290.32,54.85 L283.42,93.61 C282.797709,96.6926511 280.142784,98.9464427 277,99.06 Z",
    id: "Path",
    fill: "#E5E9F1",
    fillRule: "nonzero"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFBC00",
    fillRule: "nonzero",
    transform: "translate(123.378043, 74.289188) rotate(-42.460000) translate(-123.378043, -74.289188) ",
    cx: 123.378043,
    cy: 74.2891877,
    rx: 17.51,
    ry: 14.66
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.6,
    transform: "translate(147.000000, 61.000000)",
    fill: "#B4BED5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(3.000000, 0.000000)",
    id: "Path"
  }, _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "68.25 0.2 1.45 0.2 0.75 4.12 67.55 4.12"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(1.000000, 11.000000)",
    id: "Path"
  }, _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "122.04 0.27 1.51 0.27 0.78 4.19 121.32 4.19"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(0.000000, 22.000000)",
    id: "Path"
  }, _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "82.29 0.34 1.23 0.34 0.43 4.59 81.5 4.59"
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M335.53,169.55 L198.76,169.55 C197.379827,169.598118 196.055847,169.001281 195.177928,167.935236 C194.300008,166.869191 193.968123,165.455335 194.28,164.11 L201.18,125.34 C201.803014,122.259342 204.458863,120.008903 207.6,119.9 L344.37,119.9 C345.751508,119.847754 347.078202,120.443462 347.957065,121.510652 C348.835928,122.577843 349.166184,123.994146 348.85,125.34 L342,164.11 C341.369284,167.206371 338.68868,169.460233 335.53,169.55 Z",
    id: "Path",
    fill: "#E5E9F0",
    fillRule: "nonzero"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.75,
    transform: "translate(194.000000, 119.000000)",
    stroke: "#B8BBC1",
    strokeDasharray: 5.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.53,50.55 L4.76,50.55 C3.37982653,50.5981184 2.05584688,50.0012811 1.17792753,48.9352362 C0.300008171,47.8691912 -0.0318772883,46.4553352 0.28,45.11 L7.18,6.34 C7.80301446,3.25934187 10.458863,1.00890323 13.6,0.9 L150.37,0.9 C151.751508,0.847754131 153.078202,1.44346208 153.957065,2.51065237 C154.835928,3.57784266 155.166184,4.9941463 154.85,6.34 L148,45.11 C147.369284,48.2063712 144.68868,50.4602332 141.53,50.55 Z",
    id: "Path"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(200.000000, 122.000000)",
    fill: "#B4BED5",
    fillRule: "nonzero"
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    transform: "translate(23.431096, 23.387118) rotate(-43.550000) translate(-23.431096, -23.387118) ",
    cx: 23.4310959,
    cy: 23.3871184,
    rx: 16.85,
    ry: 15.23
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.3,
    transform: "translate(247.000000, 132.000000)",
    fill: "#9BA9C5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "48.32 0.35 4.75 0.35 4.05 4.27 47.62 4.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "85.41 11.42 2.81 11.42 2.08 15.34 84.69 15.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "26.58 22.49 1.53 22.49 0.73 26.74 25.79 26.74"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.4,
    transform: "translate(192.000000, 357.000000)",
    fill: "#9BA9C5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "83.89 0.09 1.3 0.09 0.57 4.01 83.18 4.01"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.4,
    transform: "translate(258.000000, 43.000000)",
    fill: "url(#linearGradient-7)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.55,
    y: 0.34,
    width: 103.84,
    height: 61.76
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M455.78,105.1 L320.78,105.1 C319.070743,105.161693 317.4307,104.421791 316.345814,103.099525 C315.260928,101.777259 314.855627,100.024282 315.25,98.36 L323.79,50.36 C324.556443,46.5456774 327.841842,43.7568128 331.73,43.62 L466.73,43.62 C468.43964,43.5592339 470.079895,44.2988999 471.166174,45.6204743 C472.252453,46.9420488 472.660588,48.6944662 472.27,50.36 L463.73,98.36 C462.956018,102.173916 459.669158,104.960512 455.78,105.1 L455.78,105.1 Z",
    id: "Path",
    fill: "#00DBFF",
    fillRule: "nonzero"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#00DBFF",
    fillRule: "nonzero",
    points: "305.83 74.37 318.11 82.27 320.92 66.47"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "449.61 58.07 340.18 58.07 339.32 62.92 448.75 62.92"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "446.69 71.77 337.78 71.77 336.88 76.62 445.8 76.62"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "384.85 85.48 336.19 85.48 335.21 90.73 383.87 90.73"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M170.93,219.46 L186.27,219.46 C198,219.46 195,206 201.89,206 C208.78,206 207.45,218.09 216.89,218.09 C226.33,218.09 222.71,199.09 231.97,199.09 C240.42,199.09 238.91,216.98 251.44,219.51",
    id: "Path",
    stroke: "#CCCCCC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M186.4,219.46 C190.63,219.46 192.26,218.02 193.51,216.61 C197.06,212.61 197.07,205.99 201.86,205.99 C208.74,205.99 207.45,218.08 216.92,218.08 C226.39,218.08 222.72,199.08 231.98,199.08 C240.38,199.08 238.98,216.6 250.98,219.31",
    id: "Path",
    stroke: "#F4674C"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#F4674C",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 232.07,
    cy: 199.19,
    r: 1.63
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#F4674C",
    strokeWidth: 0.25,
    cx: 232.07,
    cy: 199.19,
    r: 3.54
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M303.92,335.72 L168.92,335.72 C167.21036,335.780766 165.570105,335.0411 164.483826,333.719526 C163.397547,332.397951 162.989412,330.645534 163.38,328.98 L171.38,282.62 C172.153092,278.809601 175.434633,276.02401 179.32,275.88 L314.32,275.88 C316.02964,275.819234 317.669895,276.5589 318.756174,277.880474 C319.842453,279.202049 320.250588,280.954466 319.86,282.62 L311.86,328.98 C311.093557,332.794323 307.808158,335.583187 303.92,335.72 Z",
    id: "Path",
    fill: "#EDF0F4",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.4,
    transform: "translate(216.000000, 297.000000)",
    fill: "#B4BED5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(1.000000, 0.000000)",
    id: "Path"
  }, _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.1 0.63 1.37 0.63 0.64 4.55 86.38 4.55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(0.000000, 12.000000)",
    id: "Path"
  }, _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "45.26 0.72 1.09 0.72 0.29 4.96 44.48 4.96"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(169.000000, 283.000000)",
    fill: "#B4BED5",
    fillRule: "nonzero"
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    transform: "translate(22.818355, 22.794155) rotate(-43.550000) translate(-22.818355, -22.794155) ",
    cx: 22.8183552,
    cy: 22.7941552,
    rx: 16.85,
    ry: 15.23
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M127.7,71.27 L120.21,71.27 L120.33,70.56 C120.717509,68.7529909 122.292498,67.4467011 124.14,67.4 L125.14,67.4 C125.949326,67.3630001 126.729946,67.703937 127.252831,68.322782 C127.775716,68.9416271 127.981571,69.7682038 127.81,70.56 L127.7,71.27 Z M122.06,69.86 L126.35,69.86 C126.146737,69.2339089 125.547235,68.8232916 124.89,68.86 L123.89,68.86 C123.151192,68.866479 122.464493,69.2417247 122.06,69.86 L122.06,69.86 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "130.46 76.85 128.31 76.85 128.56 75.43 130.71 75.43"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "117.75 76.85 115.47 76.85 115.72 75.43 118 75.43"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M129.5,73.62 L131,73.62 L131.25,72.2 L128.25,72.2 L127.45,76.68 C127.075549,78.4657865 125.52396,79.7608464 123.7,79.81 L121.09,79.81 C120.288486,79.8472938 119.515246,79.5095536 118.997921,78.8962102 C118.480596,78.2828668 118.278083,77.4637471 118.45,76.68 L119.25,72.2 L116.25,72.2 L116,73.62 L117.56,73.62 L117.01,76.68 C116.848895,77.5196218 116.961043,78.3887732 117.33,79.16 L115.85,80.38 L116.7,81.38 L118.11,80.21 C118.864914,80.8763204 119.843357,81.2334165 120.85,81.21 L123.46,81.21 C124.618194,81.1943927 125.741778,80.8128643 126.67,80.12 L127.73,81.37 L128.93,80.37 L127.82,79.06 L127.73,79.13 C128.365041,78.4417609 128.803643,77.5956386 129,76.68 L129.5,73.62 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M126.3,72.2 C125.278956,72.2230557 124.306991,72.6426864 123.59,73.37 C123.078418,72.6124173 122.213664,72.1705998 121.3,72.2 L119.3,72.2 L119,73.62 L121,73.62 C121.443925,73.5966171 121.873183,73.7824749 122.15989,74.122203 C122.446597,74.4619311 122.557663,74.9163204 122.46,75.35 L121.65,79.92 L121.42,81.22 L122.87,81.22 L123.1,79.92 L123.91,75.35 C124.125835,74.3612646 124.98835,73.6473173 126,73.62 L128,73.62 L128.25,72.2 L126.3,72.2 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M444,188.08 C441.956067,185.686511 438.957316,184.32078 435.81,184.349541 L267.71,184.349541 C261.638557,184.482706 256.480443,188.82901 255.32,194.79 L248.42,233.56 C247.825094,236.69289 248.653142,239.928139 250.68,242.39 C252.030763,243.99343 253.837445,245.147893 255.86,245.7 L255.74,245.7 L336.27,272.81 L340.94,246.13 L427,246.13 C433.069318,245.987911 438.221034,241.63933 439.38,235.68 L446.28,196.92 C446.873953,193.780844 446.038153,190.540287 444,188.08 L444,188.08 Z",
    id: "Path",
    fill: "url(#linearGradient-8)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("image", {
    id: "Bitmap",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply"
    },
    x: 239.22,
    y: 175.3,
    width: 217,
    height: 80,
    xlinkHref: "data:image/png;base64,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"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M427,240.06 L258.87,240.06 C257.488492,240.112246 256.161798,239.516538 255.282935,238.449348 C254.404072,237.382157 254.073816,235.965854 254.39,234.62 L261.29,195.86 C261.912291,192.777349 264.567216,190.523557 267.71,190.41 L435.84,190.41 C437.221996,190.360145 438.547993,190.95852 439.424976,192.027772 C440.301959,193.097024 440.629308,194.514474 440.31,195.86 L433.41,234.62 C432.794546,237.701071 430.140144,239.953793 427,240.06 Z",
    id: "Path",
    fill: "#E5E9F1",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.6,
    transform: "translate(308.000000, 202.000000)",
    fill: "#B4BED5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(3.000000, 0.000000)",
    id: "Path"
  }, _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "34.93 0.21 1.53 0.21 0.83 4.12 34.23 4.12"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(1.000000, 11.000000)",
    id: "Path"
  }, _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "111.04 0.28 1.59 0.28 0.86 4.2 110.32 4.2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(0.000000, 22.000000)",
    id: "Path"
  }, _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "66 0.35 1.3 0.35 0.51 4.59 65.21 4.59"
  })))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F4674C",
    fillRule: "nonzero",
    transform: "translate(284.160371, 215.234820) rotate(-43.620000) translate(-284.160371, -215.234820) ",
    cx: 284.160371,
    cy: 215.23482,
    rx: 16.81,
    ry: 15.27
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M285.7,222.66 L281.19,222.66 C280.66178,222.670021 280.155002,222.451268 279.8,222.06 L276.92,218.87 C276.564694,218.475644 276.397005,217.947058 276.46,217.42 L276.89,212.91 C276.948913,212.3518 277.212547,211.835221 277.63,211.46 L281.13,208.27 C281.538995,207.892016 282.073152,207.678353 282.63,207.669955 L287.15,207.669955 C287.676946,207.666355 288.181232,207.884032 288.54,208.27 L291.42,211.46 C291.770765,211.856943 291.937793,212.383445 291.88,212.91 L291.44,217.42 C291.385838,217.979599 291.121374,218.497806 290.7,218.87 L287.2,222.06 C286.794185,222.442991 286.257998,222.657466 285.7,222.66 L285.7,222.66 Z M282.5,209 C282.31413,209.001505 282.135633,209.072903 282,209.2 L278.5,212.39 C278.361133,212.513093 278.275154,212.68505 278.26,212.87 L277.82,217.38 C277.799953,217.554005 277.854442,217.728371 277.97,217.86 L280.86,221.06 C280.980758,221.183782 281.147089,221.252484 281.32,221.250065 L285.83,221.250065 C286.013851,221.247578 286.190937,221.180286 286.33,221.06 L289.83,217.86 C289.970169,217.736691 290.059311,217.565538 290.08,217.38 L290.51,212.87 C290.532699,212.695754 290.477875,212.520316 290.36,212.39 L287.48,209.2 C287.36096,209.072535 287.194407,209 287.02,209 L282.5,209 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M283.79,219.05 C283.530486,219.054128 283.281558,218.947245 283.10583,218.756237 C282.930102,218.565228 282.844298,218.308271 282.87,218.05 C282.948166,217.48742 283.422193,217.064181 283.99,217.05 C284.249514,217.045872 284.498442,217.152755 284.67417,217.343763 C284.849898,217.534772 284.935702,217.791729 284.91,218.05 C284.839887,218.616836 284.361127,219.0443 283.79,219.05 L283.79,219.05 Z",
    id: "Path",
    fill: "#FFFFFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M283.78,215.65 L283.1,215.65 L283.52,211.28 L285.52,211.28 L285.23,214.28 C285.151737,215.032294 284.535521,215.614512 283.78,215.65 Z",
    id: "Path",
    fill: "#FFFFFF"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.6,
    transform: "translate(0.000000, 91.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.85,0.8 C149.44,0.8 189.12,47.66 180.3,105.25 C171.48,162.84 117.44,209.7 59.85,209.7",
    id: "Path",
    stroke: "url(#linearGradient-9)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.32,10.79 C142.4,10.79 178.32,53.17 170.32,105.25 C162.32,157.33 113.47,199.71 61.39,199.71",
    id: "Path",
    stroke: "url(#linearGradient-10)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.79,20.79 C135.37,20.79 167.45,58.68 160.32,105.25 C153.19,151.82 109.48,189.72 62.91,189.72",
    id: "Path",
    stroke: "url(#linearGradient-11)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.26,30.78 C128.33,30.78 156.62,64.19 150.33,105.25 C144.04,146.31 105.51,179.73 64.44,179.73 C23.37,179.73 -4.92,146.32 1.38,105.25",
    id: "Path",
    stroke: "url(#linearGradient-12)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,169.74 C30.44,169.74 6,140.81 11.4,105.25 C16.8,69.69 50.2,40.77 85.76,40.77 C121.32,40.77 145.81,69.69 140.36,105.25 C134.91,140.81 101.53,169.74 66,169.74 Z",
    id: "Path",
    stroke: "url(#linearGradient-13)",
    opacity: 0.4
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2,141.76 C54.1,141.76 25.97,166.16 21.36,196.25 C16.75,226.34 37.36,250.74 67.5,250.74 C97.64,250.74 125.73,226.35 130.34,196.25 C134.95,166.15 114.29,141.76 84.2,141.76 Z M69.86,235.32 C48.32,235.32 33.48,217.8 36.78,196.25 C40.08,174.7 60.29,157.18 81.84,157.18 C103.39,157.18 118.22,174.71 114.92,196.25 C111.62,217.79 91.41,235.32 69.86,235.32 Z",
    id: "Shape",
    fill: "url(#linearGradient-14)",
    fillRule: "nonzero"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(20.000000, 142.000000)",
    fill: "url(#linearGradient-15)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.26,8.13 L64.2,8.52 C63.8816627,10.1731895 64.2371714,11.8850424 65.1874467,13.274773 C66.1377219,14.6645035 67.6039564,15.6168602 69.26,15.92 C87.63,19.64 99.03,37.07 94.26,57.4 C89.83,76.5 71.96,91.88 52.65,93.22 C29.59,94.83 13.29,76.73 16.73,54.22 C17.4818972,49.3853654 19.0545367,44.7147952 21.38,40.41 C23.49,36.41 21.96,32.02 18.13,30.7 L17.76,30.58 C14.1,29.32 9.67,31.35 7.67,35.15 C3.95530499,42.114515 1.65130319,49.7435475 0.89,57.6 C-1.62,85.24 17.55,107.44 45,108.69 C76,110.1 105.61,85.18 110.35,54.25 C114.43,27.63 98.73,5.48 74.21,0.72 C69.75,-0.14 65,3.46 64.26,8.13 Z",
    id: "Path"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M92.42,194.51 L59.81,194.51 C58.4206805,194.552099 57.0880183,193.958238 56.1903608,192.897016 C55.2927033,191.835794 54.9280768,190.423099 55.2,189.06 L55.2,189.06 C55.7348163,185.983258 58.3586054,183.706244 61.48,183.61 L94.09,183.61 C95.4793195,183.567901 96.8119817,184.161762 97.7096392,185.222984 C98.6072967,186.284206 98.9719232,187.696901 98.7,189.06 L98.7,189.06 C98.1651837,192.136742 95.5413946,194.413756 92.42,194.51 Z",
    id: "Path",
    fill: "#32CB82",
    fillRule: "nonzero"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M83.34,208.89 L64.49,208.89 C63.6865963,208.914347 62.9158614,208.571364 62.3961474,207.958218 C61.8764334,207.345072 61.6643569,206.528559 61.82,205.74 L61.82,205.74 C62.1359232,203.961428 63.6544955,202.647279 65.46,202.59 L84.3,202.59 C85.1085658,202.556224 85.8879546,202.895166 86.4146211,203.50961 C86.9412877,204.124055 87.1570416,204.946112 87,205.74 L87,205.74 C86.6861046,207.52778 85.1545913,208.845886 83.34,208.89 Z",
    id: "Path",
    fill: "url(#linearGradient-16)",
    fillRule: "nonzero",
    opacity: 0.53
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.25,
    transform: "translate(3.000000, 298.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    transform: "translate(0.000000, 89.000000)",
    fill: "url(#linearGradient-17)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "214.5 0.85 3.39 0.85 0.91 13 212.09 13"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    transform: "translate(21.000000, 58.000000)",
    fill: "#FFFFFF",
    id: "Path"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "23.58 0.84 2.41 0.84 0.04 12.99 21.2 12.99"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    transform: "translate(60.000000, 60.000000)",
    fill: "#FFFFFF",
    id: "Path"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "55.61 0 2.79 0 0.31 12.15 53.19 12.15"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    transform: "translate(32.000000, 0.000000)",
    fill: "url(#linearGradient-18)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "75.57 0.31 2.81 0.31 0.45 12.46 73.19 12.46"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    transform: "translate(4.000000, 30.000000)",
    fill: "url(#linearGradient-19)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "86.15 0.15 2.7 0.15 0.22 12.3 83.74 12.3"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider1);
export default __webpack_public_path__ + "static/media/slider-1.7304d9933e28db15b873c263d76d5902.svg";
export { ForwardRef as ReactComponent };